import { getLSProductUri } from 'services/generic';
import { getSkuTargetingUrl } from 'services/listing/listing';
import {
  getVisuelBack,
  getVisuelBackCurvy,
  getVisuelDetail,
  getVisuelDetailCurvy,
  getVisuelFace,
  getVisuelFaceCurvy,
} from 'services/product/attributes';
import { ProductAttributesType } from 'types/ProductListing/ProductListing';

export function getPriorityStickers(
  props: Record<string, string | undefined>,
  priorityOrder: string[],
  limitResult = 2
): { key: string; value: string | undefined }[] {
  const result: { key: string; value: string }[] = [];
  for (const key of priorityOrder) {
    const value = props[key];

    if (value && value.length) {
      result.push({ key, value });
      if (result.length === limitResult) break;
    }
  }

  return result;
}

export function getPreferredVisuelFace(
  attributes: ProductAttributesType,
  preferCurvy: boolean
): string {
  const visuelFace = getVisuelFace(attributes);
  return preferCurvy
    ? getVisuelFaceCurvy(attributes) || visuelFace
    : visuelFace;
}

export function getPreferredVisuelBack(
  attributes: ProductAttributesType,
  preferCurvy: boolean
): string | undefined {
  return preferCurvy
    ? getVisuelBackCurvy(attributes)
    : getVisuelBack(attributes);
}

export function getPreferredVisuelDetail(
  attributes: ProductAttributesType,
  preferCurvy: boolean
): string | undefined {
  return preferCurvy
    ? getVisuelDetailCurvy(attributes)
    : getVisuelDetail(attributes);
}

export function getPreferredUrl(
  url: string,
  forceSkuTargeting: boolean,
  preferCurvy: boolean
): string {
  const preferredUrl = forceSkuTargeting ? getSkuTargetingUrl(url) : url;
  return preferCurvy ? getLSProductUri(preferredUrl) : preferredUrl;
}
